///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2026, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2026 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { IInfo, IMemoryInfo, IPerformanceInfo, IRenderInfo, ISceneInfo, ISystemInfo } from "./IInfo";

export class Info implements IInfo {
  public performance: IPerformanceInfo; // animate
  public render: IRenderInfo; // render
  public scene: ISceneInfo; // databasechunk
  public optimizedScene: ISceneInfo; // databasechunk
  public memory: IMemoryInfo; // databasechunk
  public system: ISystemInfo; // initialize, options, resize

  constructor() {
    this.performance = {
      fps: 0,
      frameTime: 0,
      timeToFirstRender: 0,
      loadTime: 0,
    };

    this.render = {
      viewport: { width: 0, height: 0 },
      antialiasing: "",
      drawCalls: 0,
      triangles: 0,
      points: 0,
      lines: 0,
    };

    this.scene = {
      objects: 0,
      triangles: 0,
      points: 0,
      lines: 0,
      edges: 0,
    };

    this.optimizedScene = {
      objects: 0,
      triangles: 0,
      points: 0,
      lines: 0,
      edges: 0,
    };

    this.memory = {
      geometries: 0,
      geometryBytes: 0,
      optimizedGeometryBytes: 0,
      textures: 0,
      textureBytes: 0,
      materials: 0,
      totalEstimatedGpuBytes: 0,
      usedJSHeapSize: 0,
    };

    this.system = {
      webglRenderer: "",
      webglVendor: "",
    };
  }
}
